import {CompanyType} from "../../../../types/company.type";
import React, {useContext, useEffect, useState} from "react";
import {MainContextProvider} from "../../../../context/MainContext";
import customAxios from "../../../../service/api/interceptors";
import {BookNewFollowUpTypesItemType} from "../../BookNewFollowUp/useBookNewFollowUp";
import {BusinessGoalType} from "../../../BusinessGoals/BusinessGoal.type";
import {CallListTypes} from "../FollowUpNewCalls/FollowUpNewCalls";
import {openPopupWidget} from "react-calendly";
// @ts-ignore FIX_ME
import is from 'is_js'
import {toastifyError} from "../../../../service/toastify/toastify";

const toUtcMidnightTimestamp = (date: any) => {
    if (!date) return null;

    return Math.floor(new Date(date).getTime() / 1000);
};

export const useUpcomingCallModal = (refresh: () => void, hideUpcomingFields: boolean, setSuccess: () => void) => {
    const { userData } = useContext(MainContextProvider)
    const [loading, setLoading] = useState(false)
    const [companies, setCompanies] = useState<CompanyType[]>([])
    const [types, setTypes] = useState<BookNewFollowUpTypesItemType[]>([])
    const [projects, setProjects] = useState<BusinessGoalType[]>([])
    const [availableCalls, setAvailableCalls] = useState<CallListTypes[]>([])
    const [isAvailableCallButton, setIsAvailableCallButton] = useState(false)
    const [isRemoveLink, setIsRemoveLink] = useState(false)
    const [values, setValues] = useState({
        company_id: "",
        type_id: "",
        business_goal_id: "",
        link: "",
        is_payment_required: true,
        date: null
    })
    const [isLinkError, setIsLinkError] = useState(false)
    const [isDateError, setIsDateError] = useState(false)

    const getData = async () => {
        setLoading(true)
        try {
            const { data: typesData } = await customAxios.get(`/call/types`)
            const { status, data } = await customAxios.get(`/company/company/get-companies?&is_credit_count=1`)
            const { data: availableData } = await customAxios.get(`/call/list/available`)
            if (status === 200) {
                setCompanies(data)
                setTypes(typesData)
                setAvailableCalls(availableData)

                setValues({
                    ...values,
                    company_id: data[0].id,
                    type_id: typesData[0].id,
                    link: "",
                    is_payment_required: true,
                    business_goal_id: "",
                })

                setIsRemoveLink(false)
                setIsLinkError(false)
                setIsDateError(false)
                getProjects(data[0].id)
            }
        } catch (e) {}
        setLoading(false)
    }

    const getProjects = async (id: string) => {
        setLoading(true)
        const { status, data } = await customAxios.get(`/company/${id}/business-goals`)
        setProjects([...data])
        setLoading(false)
    }

    useEffect(() => {
        getData()
    }, []);

    useEffect(() => {
        const handleEventScheduled = (event: any) => {
            if (event.data.event === "calendly.event_scheduled") {
                setSuccess()
            }
        };

        window.addEventListener("message", handleEventScheduled);

        return () => {
            window.removeEventListener("message", handleEventScheduled);
        };
    }, []);

    const changeField = (event: { target: { value: string, name: string } }) => {
        const value = event.target.value;
        const name = event.target.name;

        if (name === "company_id" && (String(value) !== String(values.company_id))) {
            getProjects(value)
            setValues({ ...values, [name]: value, business_goal_id: "" });
        } else {
            setValues({ ...values, [name]: value });
        }
    }

    const createNewCall = async (book?: boolean) => {
        const { link, type_id, company_id, date, business_goal_id, is_payment_required } = values
        setIsRemoveLink(!!(book && link))
        if (book && link) return;

        if (link && !is.url(values.link)) {
            setIsLinkError(true)
            return
        } else setIsLinkError(false);

        if (!date) {
            setIsDateError(true);
            return
        } else setIsDateError(false);

        const postData: any = {
            link, company_id, business_goal_id,
            // @ts-ignore
            date: date ? toUtcMidnightTimestamp(date) : null,
            type: type_id,
            status: hideUpcomingFields ? 2 : 0,
            is_no_payment_required: !is_payment_required ? 1 : 0,
            business_goals_list: []
        }

        if (business_goal_id) {
            postData.business_goals_list = [business_goal_id]
        }

        // /call-follow-up
        const { status, data } = await customAxios.post(`/call/create`, postData)

        if (status === 200) {
            getData()
            refresh()
            if (book) {
                if (data.call_type.link) openPopupWidget({ url: `${data.call_type.link}?utm_source=${data.id}` });
                else toastifyError("Link not exists");
            }
        }
    }

    const checkAcceptedCallButton = () => {
        const selectedCopmany = (companies || []).find(el => String(el.id) === String(values.company_id))
        const callsItem = availableCalls.find(el => (String(el.company_id) === String(values.company_id) && (String(el.call_type.id) === String(values.type_id))))
        const callTypeItem = types.find(el => String(el.id) === String(values.type_id))

        if (!values.is_payment_required) {
            setIsAvailableCallButton(true)
            return;
        }

        if (callsItem && +callsItem.count > 0) {
            setIsAvailableCallButton(true)
            return
        }

        console.log("avv", selectedCopmany?.total_credit_count, callTypeItem?.credit_price)
        if (selectedCopmany && (+selectedCopmany.total_credit_count >= +(callTypeItem?.credit_price || 0))) {
            setIsAvailableCallButton(true)
            return;
        }

        setIsAvailableCallButton(false)
    }

    useEffect(() => {
        checkAcceptedCallButton()
    }, [values.type_id, values.company_id, values.is_payment_required]);

    const selectedCategory = (companies || []).find(el => String(el.id) === String(values.company_id))
    const availableCallsItem = availableCalls.find(el => (String(el.company_id) === String(values.company_id) && (String(el.call_type.id) === String(values.type_id))))
    const type = types.find(el => String(el.id) === String(values.type_id))
    const sum = +(selectedCategory?.total_credit_count || 0) - +(type?.credit_price || 0)

    return {
        companies,
        types,
        values,
        setValues,
        changeField,
        projects,
        selectedCategory,
        loading,
        availableCallsItem,
        sum,
        type,
        createNewCall,
        isRemoveLink,
        isAvailableCallButton,
        isLinkError,
        isDateError
    }
}